//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddRole from "../RoleManagement/components/AddRole";
import RemoveRole from "../RoleManagement/components/RemoveRole";
import ModifyName from "../RoleManagement/components/ModifyName";
import ConfigRole from "../RoleManagement/components/ConfigRole";
import DetailRole from "../RoleManagement/components/DetailRole";
export default {
  name: "DefaultRoleList",
  components: {
    AddRole,
    RemoveRole,
    ModifyName,
    ConfigRole,
    DetailRole,
  },
  props: {
    systemType: {
      type: Number,
      default: () => 3,
    },
  },
  data() {
    return {
      filterForm: {
        roleName: "",
      },
      allFilters: {},
      roles: [],
      curRoleDetail: {},
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },

      curAccountDetail: {},
      ruleForm: {
        id: "",
        roleName: "",
        roleRemark: "",
      },
      loadRoles: false,
      dialogAddRoleVisible: false, // 新增角色
      dialogNameVisible: false, // 修改名称
      dialogMemberVisible: false, // 成员管理
      dialogRemoveRoleVisible: false, // 移除角色
      dialogConfigRoleAuthVisible: false, // 配置权限
      dialogRoleDetailVisible: false, // 角色详情
      operation: 1, // 1移除 2删除
    };
  },
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-24 09:27:44
     * @param {*} data 关闭弹窗type
     * @return {*}
     */
    close(data, showType) {
      this[data] = false;
      if (showType) {
        setTimeout(() => {
          let obj = {
            dialogMemberVisible: 1,
            dialogConfigRoleAuthVisible: 2,
          };
          this.operation = obj[data];
          this[showType] = true;
        }, 500);
      }
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:09
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getRoleList();
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getRoleList();
    },
    /**
     * @descripttion: 添加角色
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     * @param {*} item 当前数据项
     */
    handleAddRole(item) {
      //   this.getMenuTree();
      this.dialogAddRoleVisible = true;
    },
    /**
     * @descripttion: 修改角色名称
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditRoleName(item) {
      this.ruleForm.id = item.id;
      this.ruleForm.roleName = item.roleName;
      this.ruleForm.roleRemark = item.roleRemark;
      this.dialogNameVisible = true;
    },
    /**
     * @descripttion: 配置角色权限
     * @Author: juanjuanhui
     * @Date: 2022-02-24 17:17:58
     * @param {*} item 当前数据项
     */
    handleConfigRoleAuth(item) {
      this.curRoleDetail = item;
      //   this.getMenuTree({ roleIdList: [item.id] });
      this.dialogConfigRoleAuthVisible = true;
    },
    /**
     * @descripttion: 查看角色详情
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:42:50
     * @param {*} item 当前数据项
     */
    handleLookRoleDetail(item) {
      this.curRoleDetail = item;
      this.dialogRoleDetailVisible = true;
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getRoleList();
    },
    /**
     * @description: 获取角色列表
     * @Author: yangsibo
     * @Date: 2022-05-23 17:45:52
     * @return {*}
     */
    async getRoleList() {
      this.loadRoles = true;
      this.roles = [];
      try {
        let { data } = await this.$http.role.getSRoleListNum({
          ...this.filterForm,
          ...this.pagination,
          systemType: this.systemType,
          masterId: 2,
        });
        if (data) {
          let { recordTotal, content: roles } = data;
          this.pagination.recordTotal = recordTotal;
          this.roles = roles;
        }
        this.loadRoles = false;
      } catch (error) {
        this.loadRoles = false;
      }
    },
  },
  created() {
    this.getRoleList();
  },
};
